export default __webpack_public_path__ + "static/media/catalunya_dark.b0a36520.png";